<template><div><h1>VUX 源码本地运行</h1>
<blockquote>
<p>phantomjs 可能会遇到无法下载的问题，建议先用 cnpm 全局安装</p>
</blockquote>
<pre class="hljs"><code>cnpm install -g phantomjs-prebuilt
</code></pre>
<div class="tip">
<p>请更新 <code>NodeJS</code> 版本到 <code>v7.6.0</code> 以上，<code>build</code> 命令逐步使用 <code>async</code>。</p>
</div>
<pre class="hljs"><code>yarn <span class="hljs-comment"># 使用 yarn.lock 保证依赖版本一致</span>
yarn dev <span class="hljs-comment"># 或者 npm run dev</span>


yarn dev -- --env.include datetime,alert <span class="hljs-comment"># 只运行部分组件，耗时短</span>
</code></pre>
<h2>本地查看文档</h2>
<pre class="hljs"><code>npm run doc:build // 构建文档
<span class="hljs-built_in">cd</span> docs
yarn
npm run dev // 耗时较长
</code></pre>
<h2>文档相关命令</h2>
<blockquote>
<p>docs 目录下的相关命令，它们是 npm run doc:build 的一部分，但是可以单独运行</p>
</blockquote>
<pre class="hljs"><code>node compile // 生成文档路由
node component-contributions // 从 git 记录里获取每个组件提交历史

npm run doc:dev // 运行
</code></pre>
<h2>构建部分文档</h2>
<p>文档页面比较多等待 build 命令会长，因此可以只构建部分文档方便快速查看。</p>
<pre class="hljs"><code><span class="hljs-built_in">cd</span> docs
node compile --include datetime // 只构建 datetime 相关文档，多个时以英文逗号分隔，如：datetime,alert
npm run dev
</code></pre>
<h2>官网文档部署说明</h2>
<p>线上页面有 <code>30分钟</code> 页面缓存，定时每 <code>20分钟</code> 构建一次，因此提交后可能会需要 <code>1小时</code> 才会更新到官网。</p>
</div></template><script>
export default {
  head: {"title":"VUX 源码本地运行 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// vux-development-277.vue?25552324